import { render } from "./TheCard.vue?vue&type=template&id=5a182ecb"
import script from "./TheCard.vue?vue&type=script&lang=js"
export * from "./TheCard.vue?vue&type=script&lang=js"

import "./TheCard.vue?vue&type=style&index=0&id=5a182ecb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__